import React from 'react';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
} from 'reactstrap';

import styles from './Offer.styles.module.scss';
import stringTable from '../../config/stringTable';

const englishIsTheOnlyLanguageSupported = 'en';

export default function OfferDeclinedView({ offer }) {
  const { errorType, status, returnUrl } = offer;
  if (errorType || status !== 'declined') return null;
  if (returnUrl) {
    window.location.href = returnUrl;
  }
  const wordings = stringTable[englishIsTheOnlyLanguageSupported];
  return (
    <Card>
      <CardBody className={styles.card}>
        <CardTitle tag="h5">
          { wordings['Offer Declined'] }
        </CardTitle>
        <CardText>
          { wordings['The offer has been declined.'] }
        </CardText>
        <CardText>
          { returnUrl && wordings['Redirecting you to find another offer.'] }
        </CardText>
      </CardBody>
    </Card>
  );
}
